// this file helps webpack include only the modules that are necessary
// for the build environment
if (__DEV__) {
  module.exports = require("./configure.dev");
} else if (__STAGING__) {
  module.exports = require("./configure.staging");
} else {
  module.exports = require("./configure.prod");
}
